import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { AuthLayoutComponent } from "./layout/auth-layout/auth-layout.component";
import { AppLayoutComponent } from "./layout/app-layout/app-layout-component";

import { AUTH_LAYOUT_ROUTES } from "./routes/auth-layout.routes";
import { APP_LAYOUT_ROUTES } from './routes/app-layout.routes';
import { LoginComponent } from './views/auth/login/login.component';
import { AuthGuard } from './auth.guard';

const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
    },
    {
        path:'login',
        component:LoginComponent
    },
    { 
        path: '', 
        canActivate: [AuthGuard],
        component: AppLayoutComponent,
        children: APP_LAYOUT_ROUTES 
    },
    { 
        path: '', 
        component: AuthLayoutComponent, 
        children: AUTH_LAYOUT_ROUTES
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            useHash: true
        })
    ],
    exports: [
        RouterModule
    ]
})

export class AppRoutingModule {
}